module.exports = __webpack_public_path__ + "media/firecracker.974b7cff.mp3";